import { createTheme, colors } from '@mui/material';
import shadows from './shadows';
import typography from './typography';
import BreakPoints from './breakPoints';

const theme = createTheme({
    breakpoints: {
        values: BreakPoints,
    },
    palette: {
        background: {
            dark: '#2F4858',
            gray: '#EBEBEB',
            gradient: 'linear-gradient(65.54deg, #FE7563 12.26%, #FE7663 20.52%, #FE9368 83.36%)',
            default: colors.common.white,
            paper: colors.common.white,
            green: '#98FFAF',
            red: '#FF8282',
        },
        borders: {
            green: '#81DF96',
            red: '#EB6969',
            gray: '#CFCFCF',
        },
        primary: {
            main: '#2F4858',
            light: colors.common.white,
        },
        secondary: {
            main: '#2F4858',
            background: '#2F4858',
            light: colors.common.white,
            contrastText: colors.common.white,
        },
        text: {
            main: '#FFF',
            primary: '#000',
            secondary: '#656565',
            // secondary: colors.blueGrey[600],
            black: 'black',
            darkGray: '#4D4D4D',
            bttnGray: '#575757',
            lightBlue: '#2C67DA',
            gray: '#666666',
            lightGray: '#BDBFD8',
            green: '#3C7129',
            red: '#E02B2F',
            white: '#FFFFFF',
            yellow: '#FC902D',
            orange: '#C1854D',
            textPrimary: '#FFF',
        },
    },
    shadows,
    typography,
});

export default theme;
